import React from 'react';

interface FormRowProps extends React.HTMLAttributes<HTMLDivElement> {
  /**
   * Tailwind grid-template-columns classes, e.g. `grid-cols-[1fr_104px]`.
   * Defaults to two equal columns.
   */
  columns?: string;
}

/*
 * Places several fields on one row (Figma: "Straße und Hausnummer",
 * "Postleitzahl und Ort"). 20px gutter between the columns.
 */
const FormRow: React.FC<FormRowProps> = ({
  columns = 'grid-cols-2',
  className = '',
  children,
  ...props
}) => (
  <div className={`grid w-full gap-5 ${columns} ${className}`} {...props}>
    {children}
  </div>
);

export default FormRow;
